import { useEffect, useState } from "react";
import { API } from "../lib/api";
import SalaryCard from "../components/hris/SalaryCard";

export default function SalaryPublic() {
  const [slip, setSlip] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const robot = document.createElement("meta");
    robot.name = "robots"; robot.content = "noindex, nofollow, noarchive";
    document.head.appendChild(robot);
    return () => robot.remove();
  }, []);
  useEffect(() => {
    const controller = new AbortController();
    const token = window.location.hash.slice(1);
    if (!/^[A-Za-z0-9_-]{43,80}$/.test(token)) { setError("Tautan slip tidak lengkap. Minta tautan baru kepada HR."); return; }
    fetch(`${API}/payroll/public`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token }), cache: "no-store", referrerPolicy: "no-referrer", signal: controller.signal })
      .then(async res => { if (!res.ok) throw new Error(res.status === 404 ? "Tautan kedaluwarsa atau sudah dicabut. Minta tautan baru kepada HR." : "Slip belum dapat dimuat. Coba lagi sebentar."); return res.json(); })
      .then(setSlip).catch(e => { if (e.name !== "AbortError") setError(e.message); });
    return () => controller.abort();
  }, []);
  return <main className="salary-page">{slip ? <SalaryCard slip={slip} /> : <div className="salary-state" role={error ? "alert" : "status"}><h1>{error ? "Slip tidak tersedia" : "Memuat slip gaji…"}</h1>{error && <p>{error}</p>}</div>}</main>;
}
